module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white content-padded"
  }, [_c('div', [_vm._v("\n    页面路径："), _c('a', {
    staticClass: "page-name",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.detail.monitor_path)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.monitor_path_params != ''),
      expression: "detail.monitor_path_params != ''"
    }]
  }, [_vm._v("?" + _vm._s(_vm.detail.monitor_path_params))])]), _c('span', [_vm._v("小程序：" + _vm._s(_vm.detail.nick_name))])]), _vm._v(" "), _c('div', {
    staticClass: "time-box"
  }, [_c('div', [_c('span', [_vm._v("日期筛选：")]), _vm._v(" "), _c('el-select', {
    on: {
      "change": _vm.timeTypeChange
    },
    model: {
      value: (_vm.timeType),
      callback: function($$v) {
        _vm.timeType = $$v
      },
      expression: "timeType"
    }
  }, _vm._l((_vm.timeTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.isNeardate) ? _c('span', [_vm._v(_vm._s(_vm.typeText)), (_vm.isRealTime) ? _c('span', {
    staticClass: "refresh",
    on: {
      "click": _vm.getRealTime
    }
  }, [_vm._v(" 刷新")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ischooseDay) ? _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.chooseDate),
      callback: function($$v) {
        _vm.chooseDate = $$v
      },
      expression: "chooseDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.iscustom) ? _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions2
    },
    model: {
      value: (_vm.customDate),
      callback: function($$v) {
        _vm.customDate = $$v
      },
      expression: "customDate"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.searchStats
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "time-box basic"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("新客访问量: "), _c('span', [_vm._v(_vm._s(_vm.statstotal.total_fans_num))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("注册量: "), _c('span', [_vm._v(_vm._s(_vm.statstotal.total_register_num))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("购买量: "), _c('span', [_vm._v(_vm._s(_vm.statstotal.total_entries_num))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("注册购买转化率: "), _c('span', [_vm._v(_vm._s(_vm.statstotal.total_register_entries_rate))])])], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.codePack
    }
  }, [_vm._v("二维码打包")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "row-key": _vm.handleRowKey
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "source_id",
      "label": "来源ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "monitor_id",
      "label": "跟踪ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source_name",
      "label": "来源名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fans_num",
      "label": "新客访问量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "register_num",
      "label": "注册量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "entries_num",
      "label": "购买量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "register_entries_rate",
      "label": "转化率"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.showlink(scope.row)
            }
          }
        }, [_vm._v("链接")]), _vm._v("  \n          "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "二维码信息",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "before-close": _vm.cancelDialog
    }
  }, [
    [_c('el-alert', {
      attrs: {
        "title": "将此链接或二维码进行投放，获取对应跟踪数据",
        "type": "warning",
        "closeable": false
      }
    }), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("来源名称")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 15
      }
    }, [_vm._v(_vm._s(_vm.wxaCodeInfo.source_name))])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("跟踪二维码")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 15
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      attrs: {
        "src": _vm.wxaCodeInfo.code_src
      }
    })])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 15
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.downloadCode(_vm.wxaCodeInfo.source_name, _vm.wxaCodeInfo.code_src)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-download"
    }), _vm._v("下载二维码")])])], 1)]
  ], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "二维码打包下载",
      "visible": _vm.codeDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.codeDialogVisible = $event
      }
    }
  }, [(_vm.dataList.length > 0) ? _vm._l((_vm.dataSpan), function(item, index) {
    return _c('div', {
      staticClass: "code-span",
      class: {
        'cur': index === _vm.codespanIndex
      },
      on: {
        "click": function($event) {
          return _vm.codeSpanChoose(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item))]), _vm._v(" "), (index === _vm.codespanIndex && !_vm.isdownloadOk) ? _c('span', {
      staticClass: "bg-waiting"
    }, [_c('i', {
      staticClass: "el-icon-loading"
    })]) : _vm._e(), _vm._v(" "), (index === _vm.codespanIndex && _vm.isdownloadOk) ? _c('span', {
      staticClass: "download-ok"
    }, [_c('i', {
      staticClass: "el-icon-circle-check"
    })]) : _vm._e()])
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8693aafe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8693aafe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/statistics/sourcemanagement/monito_detail.vue
// module id = 2873
// module chunks = 0